import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';
import { PageLayout } from '@/components/ui/PageLayout';
import { TYPE } from '@/lib/typography';

interface PlaceholderPageProps {
  titleKey: string;
  modKey: string;
}

/**
 * Stand-in shell for module pages until each MOD-N issue ships its own UI.
 * Keeps the navigation reachable and proves auth/RLS routing works end-to-end.
 */
export function PlaceholderPage({ titleKey, modKey }: PlaceholderPageProps) {
  const { t } = useTranslation();
  return (
    <PageLayout title={t(titleKey)}>
      <div className="rounded-card border border-dashed border-ds-line bg-ds-card p-s7 text-center">
        <Construction className="mx-auto h-10 w-10 text-ds-muted" />
        <h2 className={`mt-s3 text-ds-text ${TYPE.section}`}>
          {t('placeholder.module_pending')}
        </h2>
        <p className={`mt-s1 text-ds-muted ${TYPE.body}`}>
          {t('placeholder.module_pending_long')}
        </p>
        <p className={`mt-s3 font-mono ${TYPE.caption} text-ds-muted`}>{modKey}</p>
      </div>
    </PageLayout>
  );
}
